import { DateTime } from 'luxon';
import { MarketSession } from './formatters';

export const getCurrentMarketSession = (dateTime?: DateTime): MarketSession => {
  const currentETDateTime = DateTime.now().setZone('America/New_York');
  const hour = dateTime?.hour ?? currentETDateTime.hour;
  const minute = dateTime?.minute ?? currentETDateTime.minute;
  const totalMinutes = hour * 60 + minute;

  // Market times in EST/EDT (adjust timezone as needed)
  const preMarketStart = 4 * 60; // 4:00 AM
  const regularMarketStart = 9 * 60 + 30; // 9:30 AM
  const regularMarketEnd = 16 * 60; // 4:00 PM
  const afterHoursEnd = 20 * 60; // 8:00 PM

  if (totalMinutes >= preMarketStart && totalMinutes < regularMarketStart) {
    return MarketSession.preMarket;
  } else if (totalMinutes >= regularMarketStart && totalMinutes < regularMarketEnd) {
    return MarketSession.regular;
  } else if (totalMinutes >= regularMarketEnd && totalMinutes < afterHoursEnd) {
    return MarketSession.afterHours;
  } else {
    return MarketSession.closed;
  }
};
